export interface MarketSignalStreamAnalysisTopic {
  text: string;
  sentiment: number;
  relevance: number;
  ids: string[];
  context: string;
  followupQuestions?: string[];
}

export interface MarketSignalStreamAnalysisLocation {
  country: string;
  text: string;
  latitude: number;
  longitude: number;
  ids: string[];
  sentiment: number;
}

export interface MarketSignalStreamAnalysis {
  stream: string;
  dateCreated: Date;
  topics: MarketSignalStreamAnalysisTopic[];
  summary: string;
  sourceLocations: MarketSignalStreamAnalysisLocation[];
  signalSourceIds: string[];
}

export function fixMarketSignalStreamAnalysis(
  a: MarketSignalStreamAnalysis,
): MarketSignalStreamAnalysis {
  if (!a.topics) a.topics = [];

  if (!a.sourceLocations) a.sourceLocations = [];

  a.topics.forEach((value, index) => {
    if (typeof value === 'string') {
      a.topics[index] = {
        ids: [],
        followupQuestions: [],
        sentiment: 0,
        text: value,
        relevance: 1,
        context: value,
      };

      return;
    }

    if (!value.ids) value.ids = [];
  });

  return a;
}
